<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      v-dialog-drag
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_PleaseSelectTheSailingScheduleBelow')"
      width="805px"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="app-main-content"
    >
      <div class="grid-view" style="height: 280px;">
        <p><strong>{{ $t('BusinessIntelligence.businessIntelligenceChart.warmPrompt') }}</strong></p>
        <span>{{ $t('CargoMsg.Cargo_ChooseShippingSchedulesTips1') }}</span>
        <p>{{ $t('CargoMsg.Cargo_ChooseShippingSchedulesTips2') }}</p>
        <div class="main-content">
          <div class="section grid-wrapper">
            <cargo-ag-grid
              :grid-options="gridOptions"
              :show-side-bar="false"
              :column-defs="columnDefs"
              :row-data="shippingSchedules"
              min-height="300px"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="enterEvent">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="cancel">{{ $t('CargoMsg.Cargo_NoSelectYet') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  shippingScheduleDistrict,
  syncScheduleDataToJobBySchedule
} from '@/api/seaExport/dataTracking'
import { getLoading } from '@/utils/utilBaseElement'
import dateUtils from '@/utils/dateUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { Job } from '@/class/model/booking/Job'

export default {
  name: 'ChooseShippingSchedules',
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    job: { type: Object, required: true }, // 业务信息
    isBtn: { type: Boolean, default: false },
    chooseShippingSchedule: { type: String, required: true }, // 选择的港区
    shippingSchedules: { type: Array, required: true }
  },
  data() {
    return {
      loading: null,
      selectedRow: null,
      gridOptions: {
        rowSelection: 'single',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.rowClicked
      },
      columnDefs: [
        { headerName: this.$t('SeaExport.Vessel'), field: 'vessel', flex: 1,
          colId: 'vessel', width: 140 },
        { headerName: this.$t('SeaExport.Voyage'), field: 'voyage', flex: 1,
          colId: 'voyage', width: 140 },
        { headerName: this.$t('SeaExport.Wharf'), field: 'portDistrict', flex: 1,
          colId: 'portDistrict', width: 140 },
        { headerName: this.$t('SeaExport.PlannedBerthingTime'), field: 'berthPlanDate', flex: 1,
          colId: 'berthPlanDate', width: 140,
          cellRenderer: (params) => {
            if (!params.value) {
              return ''
            }
            return dateUtils.dateFormatYmdHms(params.value)
          }
        },
        { headerName: this.$t('SeaExport.PlanDepartureTime'), field: 'unberthPlanDate', flex: 1,
          colId: 'unberthPlanDate', width: 140,
          cellRenderer: (params) => {
            if (!params.value) {
              return ''
            }
            return dateUtils.dateFormatYmdHms(params.value)
          }
        }
      ]
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  mounted() {
    // 默认选中第一条
    this.$nextTick(() => {
      this.gridOptions.api.forEachNode((node, index) => {
        if (!this.chooseShippingSchedule && index === 0) {
          node.setSelected(true)
          this.selectedRow = node.data
        }
        if (this.chooseShippingSchedule === node.data.portDistrict) {
          node.setSelected(true)
          this.selectedRow = node.data
        }
      })
    })
  },
  methods: {
    cancel() {
      LocalStorageUtils.setConfiguration('loadShippingSchedules_' + this.job.uuid, '1')
      this.$emit('close')
    },
    enterEvent() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      const params = {
        portDistrict: this.selectedRow.portDistrict, jobUuid: this.job.jobUuid, tenantId: this.job.tenantId
      }
      this.loading = getLoading()
      // 保存选择
      shippingScheduleDistrict(params).then(async res => {
        if (!this.isBtn) {
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        }
        this.loading.close()
        this.job.berthPlanDate = this.selectedRow.berthPlanDate
        this.job.unBerthPlanDate = this.selectedRow.unberthPlanDate
        this.job.portDistrict = this.selectedRow.portDistrict
        const jobUuids = []
        jobUuids.push(this.job.uuid)
        // 如果是主票，同步修改小票
        if (this.job.masterFlag) {
          // 遍历小票
          const lclSlaves = await new Job(this.job).getLclSlaves()
          for (const lclSlave of lclSlaves) {
            jobUuids.push(lclSlave.uuid)
            lclSlave.berthPlanDate = this.selectedRow.berthPlanDate
            lclSlave.unBerthPlanDate = this.selectedRow.unberthPlanDate
            lclSlave.portDistrict = this.selectedRow.portDistrict
          }
        }
        // 同步数据
        // 如果是弹窗进入，则调用接口
        if (!this.isBtn) {
          // 非弹窗进入，修改业务及其小票的对应的数据
          await syncScheduleDataToJobBySchedule({ jobUuid: jobUuids }).then(result => {
          }).catch(() => {
          })
        }
        this.cancel()
      }).catch(() => {
        this.loading.close()
      })
    },
    rowClicked(event) {
      this.selectedRow = event.data
    }
  }
}
</script>

<style scoped>

</style>
